import React from 'react';
import { Paper, Typography, Grid, Tooltip, IconButton, useTheme, ToggleButton } from '@mui/material';
import { usePhotoAddsStore } from '../usePhotoAddsStoreBridge';
import { TOOL_DEFS } from '../constants/tools';
import { PanTool, Brush, TextFields, Rectangle, RadioButtonUnchecked, Timeline, Crop } from '@mui/icons-material';

const iconMap = {
  select: <PanTool />,
  brush: <Brush />,
  text: <TextFields />,
  rectangle: <Rectangle />,
  circle: <RadioButtonUnchecked />,
  line: <Timeline />,
  crop: <Crop />,
};

const ToolsPanel = ({ onToolClick }) => {
  const theme = useTheme();
  const { selectedTool } = usePhotoAddsStore();
  return (
    <Paper sx={{ width: '100%', bgcolor: theme.palette.background.paper, borderRadius: 0, borderRight: `1px solid ${theme.palette.divider}`, p: 1 }}>
      <Typography variant="subtitle2" sx={{ color: theme.palette.text.primary, mb: 1 }}>Tools</Typography>
      <Grid container spacing={1}>
        {TOOL_DEFS.map((tool) => (
          <Grid item xs={6} key={tool.id}>
            <ToggleButton
              value={tool.id}
              selected={selectedTool === tool.id}
              onChange={() => onToolClick(tool.id)}
              sx={{
                width: '100%',
                aspectRatio: '1 / 1',
                minWidth: 0,
                p: 0,
                color: theme.palette.text.primary,
                borderColor: theme.palette.divider,
                bgcolor: theme.palette.action.hover,
                border: `1px solid ${theme.palette.divider}`,
                '&:hover': { bgcolor: theme.palette.action.selected },
                '&.Mui-selected': { bgcolor: theme.palette.primary.main, color: theme.palette.primary.contrastText },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& svg': { fontSize: 28 },
              }}
            >
              <Tooltip title={tool.name}>{iconMap[tool.id]}</Tooltip>
            </ToggleButton>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default ToolsPanel;
